<template>
  <div>
    <div v-show="isSimpleList" class="aaa">
      <el-button class="btn " :disabled="noPriv" :class="noPriv ? ' ' : 'btn1'" style="margin-left: 0;float: left;"
        icon="el-icon-circle-plus-outline" @click="addDataEvent">{{
      $t("message.button.add") }}</el-button>
      <!-- <el-button class="btn btn2" icon="el-icon-delete" @click="removeCheckbox">{{
        $t("message.button.delete")
      }}</el-button> -->
      <div class="edit-table" style="float: left; overflow: hidden; height: 33px;">
        <el-button class="btn btn3" :disabled="noPriv" icon="el-icon-document-checked" @click="getUpdateEvent">{{
      $t("message.button.save")
    }}</el-button>
        <el-button class="btn btn8" icon="el-icon-circle-close" @click="closeSave">{{
      $t("message.button.cancel")
    }}</el-button>
      </div>

    </div>
    <slot></slot>

    <div style="padding: 10px 0">
      <vxe-grid ref="xGrid" auto-resize v-bind="gridOptions" @cell-dblclick="noEdit"></vxe-grid>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      existCheckbox: true,
      gridOptions: {
        keepSource: true,
        resizable: true,
        border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: "id",
        height: "510",
        size: "small",
        columns: [
          {
            field: "entryOrder",
            sortable: true,
            title: this.$t("message.table.order"),
            editRender: {
              name: "$input",
              props: {
                placeholder: this.$t("message.placeholder.input"),
              },
            },
          },
          {
            field: "entryValue",
            sortable: true,
            title: this.$t("message.table.name"),
            editRender: {
              name: "$input",
              props: {
                placeholder: this.$t("message.placeholder.input"),
              },
            },
          },
          {
            field: "description",
            sortable: true,
            title: this.$t("message.table.des"),
            editRender: {
              name: "$input",
            },
          },
          {
            field: "enabled",
            sortable: true,
            title: this.$t("message.table.status"),
            editRender: {
              name: "$select",
              options: [
                {
                  label: this.$t("message.table.enabled"),
                  value: 1,
                },
                {
                  label: this.$t("message.table.disabled"),
                  value: 0,
                },
              ],
            },
          },
        ],
        data: [],

        editConfig: {
          trigger: "dblclick",
          mode: "row",
          showIcon: false,
          activeMethod: this.activeRowMethod,
          showStatus: true,
        },
        checkboxConfig: {
          checkMethod: this.checkMethod
        },
        editRules: {
          entryValue: [
            {
              required: true,
              message: this.$t("message.warning.nameRequired"),
            },
            {
              min: 1,
              max: 200,
              message: this.$t("message.warning.length_103"),
            },
          ],
        },
        sortConfig: {
          trigger: "cell",
        },
      },
      isSimpleList: false,
      hasPriv: true,
      noPriv: false
    };
  },
  props: ["listUsed", 'editCheck'],
  methods: {
    closeSave() {
      this.$refs.xGrid.revertData(); //清除所有保存，删除，添加记录
      this.$emit('listAdd', false);
    },
    checkMethod({ row }) {
      return row.enabled
    },
    addDataEvent() {
      // console.log(this.listUsed);

      this.$refs.xGrid
        .insert({
          entryValue: "",
          description: "",
          editable: 1,
          enabled: 1,
          listId: this.$store.state.listId,
        })
        .then((res) => {
          this.$refs.xGrid.setActiveRow(res.row);
          this.$emit('listAdd', true)
        });
    },
    filterData(e) {
      this.gridOptions.data = this.baseData.filter(i =>
        (i.entryValue += '').toLowerCase().indexOf((e + '').toLowerCase()) !== -1
      );
    },

    getUpdateEvent() {
      // console.log(this.listUsed);
      this.$refs.xGrid.validate(true).then((res) => {
        if (!res) {
          let iList = this.$refs.xGrid.getInsertRecords().map(i => i.entryValue); //获取修改的行
          // console.log(insertList);
          let arr = this.$refs.xGrid.data.map(i => i.entryValue)
          arr = arr.concat(iList);
          if (this.isRepeat(arr)) {
            this.$message.error(this.$t('message.error.nameRepeat'))
            return
          }
          let updateRecords = this.$refs.xGrid.getUpdateRecords();
          // console.log(this.$refs.xGrid.getUpdateRecords());
          if (updateRecords.length !== 0) {
            //编辑
            for (var i = 0; i < updateRecords.length; i++) {
              delete updateRecords[i].id;
            }
            var update = {
              updateEntry: updateRecords,
            };
            console.log(update);
            axios
              .post("/pmdm/admin/list/updateEntry", update)
              .then(res => {
                if (res.data.code == 200) {
                  //console.log(res);
                  this.$message({
                    message: res.data.message,
                    type: "success",
                  });
                  this.getListInfo();

                }
              })
              .catch(function (error) {
                console.log(error);
              });
          }

          var insertList = this.$refs.xGrid.getInsertRecords();
          if (insertList.length !== 0) {
            for (var i = 0; i < insertList.length; i++) {
              delete insertList[i].children;
              delete insertList[i].id;
            }
            var insert = {
              insertEntry: insertList,
            };
            axios
              .post("/pmdm/admin/list/saveEntry", insert)
              .then((res) => {
                if (res.data.code == 200) {
                  console.log(res);
                  this.$message({
                    type: "success",
                    message: res.data.message,
                  });
                  this.getListInfo();
                  this.$emit('listAdd', false)

                }
              })
              .catch(function (error) {
                console.log(error);
              });
          }
        }
      });
      // //console.log(errMap);
    },
    removeCheckbox() { },
    activeRowMethod({ row, column }) {
      console.log(row);

      if (row.listId == 2014) {
        return false
      }
      return !this.noPriv

    },
    noEdit({ row }) {
      console.log(row);
      if (!row.enabled) {
        return
      }
      this.$emit('rowClick', row)
    },
    getListInfo() {
      axios.get('/pmdm/admin/list/getListEntriesSimple?listId=' + this.$store.state.listId)
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            let obj = res.data.object;
            this.noPriv = !obj.hasPriv;
            this.gridOptions.data = obj.listEntries;
            this.baseData = [...obj.listEntries];
            this.$parent.$emit('listUpdate', obj.listEntries)
            this.isSimpleList = !!obj.hasPriv;
            if (this.existCheckbox) {
              this.gridOptions.columns.unshift({
                type: "checkbox",
                width: 50,
                fixed: null,
              })
            }
            this.existCheckbox = false
          }
        })
    },
  },
  created() {
    this.getListInfo()
  }
};
</script>

<style scoped>
.btnDisable {
  color: #a1a1a1 !important;
  background: #eaeaec !important;
  border: #cecece 1px solid !important;
}

.aaa {
  margin: 0;
  overflow: hidden;
}

.btn {
  display: inline-block;
  padding: 4px;
  padding-right: 10px;
  border-radius: 3px;
  cursor: pointer;
  font-size: 14px;
}

.btn i {
  display: inline-block;
  width: 18px;
  height: 18px;
  position: relative;
  top: 3px;
  font-size: 14px;
}

.btn span {
  position: relative;
  padding: 0 2px;
}

.btn img {
  height: 100%;
  width: 100%;
}

.btn1 {
  height: 32px;
  color: #4b92ff;
  border-color: rgba(75, 146, 255, 0.5);
  background: rgba(75, 146, 255, 0.2);
}

.btn1:hover {
  color: #fff;
  background: rgba(75, 146, 255, 0.4);
}

.btn2 {
  height: 32px;
  color: #fe6263;
  border-color: rgba(254, 98, 99, 0.5);
  background: rgba(254, 98, 99, 0.2);
}

.btn2:hover {
  color: #fff;
  background: rgba(254, 98, 99, 0.4);
}

.content-title {
  padding: 0;
  margin: 0;
  overflow: hidden;
  background-size: 100% 100%;
  margin-left: 20px;
  height: 57px;
}

.content-title li {
  float: left;
  padding: 18px 12px 12px 12px;
  font-size: 16px;
  cursor: pointer;
  margin-right: 18px;
}

.content-title li:hover {
  border-bottom: 3px solid #4b92ff;
  color: #4b92ff;
}

.content-title .active {
  border-bottom: 3px solid #4b92ff;
  color: #4b92ff;
}

.btn7 {
  height: 32px;
  color: #4b92ff;
  border-color: rgba(75, 146, 255, 0.5);
  background: rgba(75, 146, 255, 0.2);
}

.btn7:hover {
  color: #fff;
  background: rgba(75, 146, 255, 0.4);
}

.btn8 {
  height: 32px;
  color: #fe6263;
  border-color: rgba(254, 98, 99, 0.5);
  background: rgba(254, 98, 99, 0.2);
}

.btn8:hover {
  color: #fff;
  background: rgba(254, 98, 99, 0.4);
}
</style>
